import Button from "@/components/ui/button";
import { useLocation } from "react-router-dom";

export function CSPrimaryBtn({
  name,
  children,
  className = "",
  variant,
  onClick,
  disable,
  type = "button",
  asChild = false,
  ...props
}) {
  const location = useLocation();

  // Determine color based on variant prop or location pathname
  const getColorClasses = () => {
    if (variant) {
      switch (variant) {
        case "live":
          return "bg-gradient-to-r from-[#9146FF] to-[#AC73FF] hover:from-[#9b4dff] hover:to-[#c18cff]";
        case "default":
        default:
          return "bg-gradient-to-r from-[#e86a33] to-[#ff8c5f] hover:from-[#ff7a3d] hover:to-[#ff9a73]";
      }
    }

    // Fallback to location-based logic
    if (location.pathname === "/live") {
      return "bg-gradient-to-r from-[#9146FF] to-[#AC73FF] hover:from-[#9b4dff] hover:to-[#c18cff]";
    } else {
      return "bg-gradient-to-r from-[#e86a33] to-[#ff8c5f] hover:from-[#ff7a3d] hover:to-[#ff9a73]";
    }
  };

  return (
    <Button
      className={`${getColorClasses()} text-white px-6 py-5 rounded-md transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl ${className}`}
      type={type}
      onClick={onClick}
      disabled={disable}
      asChild={asChild}
      {...props}
    >
      {name || children}
    </Button>
  );
}

export function CSTertiaryBtn({
  name,
  children,
  className = "",
  onClick,
  disable,
  type = "button",
  asChild = false,
  ...props
}) {
  return (
    <Button
      className={`bg-white border border-[rgba(221,221,221,0.87)] py-5 text-black hover:bg-gray-50 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl ${className}`}
      type={type}
      onClick={onClick}
      disabled={disable}
      asChild={asChild}
      {...props}
    >
      {name || children}
    </Button>
  );
}

export function CSSecondaryBtn({
  name,
  children,
  className = "",
  onClick,
  disable,
  type = "button",
  asChild = false,
  ...props
}) {
  return (
    <Button
      className={`bg-white text-[#FF6B35] hover:bg-[#fce8e0] transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl ${className}`}
      type={type}
      onClick={onClick}
      disabled={disable}
      asChild={asChild}
      {...props}
    >
      {name || children}
    </Button>
  );
}
